import React from "react";
import Link from "next/link";
import MobileSideNav from "./MobileSideNav";
import Hamburger from "../../Icons/Navbar/Hamburger";

const MobileNav = ({ openDrawer, setOpenDrawer }) => {
  return (
    <div>
      <div className="py-3 px-3 mx-auto">
        <div className="flex justify-between items-center">
          <Link href="/">
            <img
              src="/assets/headerlogo.webp"
              alt="seekho"
              className="w-[100px]"
            />
          </Link>
          <button onClick={() => setOpenDrawer(true)}>
            <Hamburger className="w-[34px]" />
          </button>
        </div>
      </div>

      {openDrawer && (
        <MobileSideNav openDrawer={openDrawer} setOpenDrawer={setOpenDrawer} />
      )}
    </div>
  );
};

export default MobileNav;
